import { createContext } from 'react';

import type { QueryMatches } from '#@/shared/hooks/useQueryMatches';

const QueryMatchesContext = createContext<QueryMatches>({
  isMobile: false,
  isTablet: false,
  isDesktop: false,
});

export default QueryMatchesContext;
